// extracted by mini-css-extract-plugin
export default {"container":"bAWGrvwRdYyUo2s","shadow":"D3Tv8RNiivCXJIk"};